import { fromJS } from 'immutable';

export const EARTHQUAKE_SEARCH_TOGGLE_EARTHQUAKE_PARAMETERS = 'EARTHQUAKE_SEARCH_TOGGLE_EARTHQUAKE_PARAMETERS';
export const EARTHQUAKE_SEARCH_TOGGLE_EARTHQUAKE_EFFECTS = 'EARTHQUAKE_SEARCH_TOGGLE_EARTHQUAKE_EFFECTS';
export const EARTHQUAKE_SEARCH_TOGGLE_EARTHQUAKE_SECONDARY_EFFECTS = 'EARTHQUAKE_SEARCH_TOGGLE_EARTHQUAKE_SECONDARY_EFFECTS';
export const EARTHQUAKE_SEARCH_TOGGLE_HAZARD_ASSOCIATION = 'EARTHQUAKE_SEARCH_TOGGLE_HAZARD_ASSOCIATION';

const initialState = fromJS({
  earthquakeParametersExpanded: true,
  earthquakeEffectsExpanded: true,
  earthquakeSecondaryEffectsExpanded: true,
  hazardAssociationExpanded: true,
});

// default param first is the redux convention https://redux.js.org/tutorials/fundamentals/part-3-state-actions-reducers
// eslint-disable-next-line default-param-last
export const earthquakeSearchPageReducer = (state = initialState, action) => {
  switch (action.type) {
    case EARTHQUAKE_SEARCH_TOGGLE_EARTHQUAKE_PARAMETERS:
      return state.set('earthquakeParametersExpanded', !state.get('earthquakeParametersExpanded'));
    case EARTHQUAKE_SEARCH_TOGGLE_EARTHQUAKE_EFFECTS:
      return state.set('earthquakeEffectsExpanded', !state.get('earthquakeEffectsExpanded'));
    case EARTHQUAKE_SEARCH_TOGGLE_EARTHQUAKE_SECONDARY_EFFECTS:
      return state.set('earthquakeSecondaryEffectsExpanded', !state.get('earthquakeSecondaryEffectsExpanded'));
    case EARTHQUAKE_SEARCH_TOGGLE_HAZARD_ASSOCIATION:
      return state.set('hazardAssociationExpanded', !state.get('hazardAssociationExpanded'));

    default:
      return state;
  }
};
